const blocks = document.querySelectorAll(
  ".wp-block-adspire-ai-tools-comparison"
);

if (blocks.length) {
  import("./view-frontend").then(({ initBlock }) => {
    blocks.forEach((block) => initBlock(block));
  });
}
